import {defineMessages} from 'react-intl';
export default defineMessages({
	title: {
		id: 'returnAuthCreateForm.step1.title',
		defaultMessage: 'Return products',
	},
	description: {
		id: 'returnAuthCreateForm.step1.description',
		defaultMessage: 'Please, select you refund method',
	},
	returnRefundsInformation: {
		id: 'returnAuthCreateForm.step1.returnRefundsInformation',
		defaultMessage: 'Click <cta>here</cta> for detailed information on returns and refunds.',
	},
	bankAccountHolderLabel: {
		id: 'returnAuthCreateForm.step1.bankAccountHolder',
		defaultMessage: 'Bank account holder*',
	},
	bankAccountHolderRequiredError: {
		id: 'returnAuthCreateForm.step1.bankAccountHolderRequiredError',
		defaultMessage: 'Bank account holder field is required',
	},
	phoneNumberLabel: {
		id: 'returnAuthCreateForm.step1.phoneNumberLabel',
		defaultMessage: 'Phone number*',
	},
	phoneNumberRequiredError: {
		id: 'returnAuthCreateForm.step1.phoneNumberRequiredError',
		defaultMessage: 'Phone number field is required',
	},
	beneficiaryBankLabel: {
		id: 'returnAuthCreateForm.step1.beneficiaryBankLabel',
		defaultMessage: 'Beneficiary bank*',
	},
	beneficiaryBankRequiredError: {
		id: 'returnAuthCreateForm.step1.beneficiaryBankRequiredError',
		defaultMessage: 'Beneficiary bank field is required',
	},
	BICSWIFTCodeLabel: {
		id: 'returnAuthCreateForm.step1.BICSWIFTCodeLabel',
		defaultMessage: 'BIC/Swift code*',
	},
	BICSWIFTCodeRequiredError: {
		id: 'returnAuthCreateForm.step1.BICSWIFTCode',
		defaultMessage: 'BICSWIFTCode field is required',
	},
	ibanLabel: {
		id: 'returnAuthCreateForm.step1.ibanLabel',
		defaultMessage: 'Iban*',
	},
	ibanRequiredError: {
		id: 'returnAuthCreateForm.step1.ibanLabelRequiredError',
		defaultMessage: 'Iban field is required',
	},
});